import {INVOICING_DASHBOARD} from './invoicing/invoicing-routing-roots';
import {Injectable} from '@angular/core';
import {CanLoad, Route, Router} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {PermissionService} from '@shared/service/permission.service';
import {Utilities} from '@shared/utilities/utilities.model';

import {ProfilePermissionModel, UserPermissionsModel} from '@shared/models/user-permission.model';
import {DL_DASHBOARD} from './delivery/delivery-routing-roots';
import {CCDKBO_DASHBOARD} from '@cc-dekra-backoffice/cc-dk-bo-routing-roots';
import {UC_DASHBOARD} from './user-change/user-change-routing-roots';
import {
	AUTHORITY_CENTER_SUPER_USER,
	AuthorityUsersPermissions,
	BookingsPermissions,
	MODULE_AUTHORITY_KEY,
	MODULE_BOOKINGS_KEY,
	PRELEASE_CENTER_SUPER_USER,
	PROFILE_ADMINISTRATION_ADMIN_KEY,
	PROFILE_ADMINISTRATION_CHANNELING_ADMIN_KEY,
	PROFILE_ADMINISTRATION_CHANNELING_RULES_SUPERADMIN,
	PROFILE_ADMINISTRATION_SUPERADMIN_KEY,
	PROFILE_ADMINISTRATION_USER_MANAGEMENT_ADMIN_KEY,
	PROFILE_ADMINISTRATION_USER_MANAGEMENT_SUPERADMIN_KEY,
	PROFILE_CLAIMS_ADMIN_KEY,
	PROFILE_CLAIMS_AON,
	PROFILE_CLAIMS_COMPLAINT_READONLY,
	PROFILE_CLAIMS_CUSTOMER_SERVICE,
	PROFILE_CLAIMS_EXTERNAL_KEY,
	PROFILE_CLAIMS_MYALD_KEY,
	PROFILE_CLAIMS_PRACTICE_CAR_KEY,
	PROFILE_CLAIMS_PRACTICE_KEY,
	PROFILE_CLAIMS_PRACTICE_READONLY,
	PROFILE_CLAIMS_REPAIR_KEY,
	PROFILE_CLAIMS_REPAIR_READONLY,
	PROFILE_CLAIMS_REPAIR_SUPERVISOR_KEY,
	PROFILE_CLAIMS_SUPERVISOR_KEY,
	PROFILE_CLAIMS_THEFT_ALD,
	PROFILE_CLAIMS_THEFT_EXTERNAL,
	PROFILE_CONTRACT_CLOSING_ADMIN_KEY,
	PROFILE_CONTRACT_CLOSING_ASSISTANCE_CENTER_KEY,
	PROFILE_CONTRACT_CLOSING_BACK_OFFICE_KEY,
	PROFILE_CONTRACT_CLOSING_RETURN_APPOINTMENT_MANAGER_KEY,
	PROFILE_CONTRACT_CLOSING_SUPER_USER_KEY,
	PROFILE_CONTRACT_CLOSING_SUPERVISOR_KEY,
	PROFILE_CONTRACT_CLOSING_SURVEYOR_KEY,
	PROFILE_DELIVERY_ADMIN_KEY,
	PROFILE_DELIVERY_ASR_KEY,
	PROFILE_DELIVERY_ASSISTANCE_CENTER_KEY,
	PROFILE_INVOICING_ADMIN_KEY,
	PROFILE_INVOICING_ASSISTANCE_CENTER_KEY,
	PROFILE_LOGISTIC_ADMIN_KEY,
	PROFILE_LOGISTIC_ASR_KEY,
	PROFILE_LOGISTIC_CENTER_SUPER_USER_KEY,
	PROFILE_LOGISTIC_CONSULTATION_KEY,
	PROFILE_LOGISTIC_TEAM_MEMBER_KEY,
	PROFILE_PUBLIC_USER_KEY,
	PROFILE_TYRE_CUSTOMER_SERVICE_KEY,
	PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY,
	PROFILE_TYRES_ADMIN_KEY,
	PROFILE_TYRES_ASSISTANCE_CENTER_KEY,
	PROFILE_TYRES_CENTER_SUPER_USER,
	PROFILE_USER_CHANGE_ADMIN_KEY,
	PROFILE_USER_CHANGE_ASSISTANCE_CENTER_KEY,
	PROFILE_USER_CHANGE_SUPER_USER_KEY,
	RELIEF_CENTER_SUPER_USER,//
	PROFILE_DELIVERY_SUPER_USER, PROFILE_CLAIMS_CUSTOM_ADMIN_KEY,  BOOKINGS_PROFILES, FLOTTA_POOL_PROFILES, PROFILES_CLAIMS_DEKRA_READONLY_KEY, PROFILE_CLAIMS_READONLY_LIST, CLAIMS_CUSTOM_ADMIN_PROFILES, PROFILE_CONTRACT_CLOSING_SUPER_ADMIN_KEY, MOBILITY_MYMOBILITY_PROFILE_USER,
	NEMO_MOBILITY_AUTHORITY_BACKOFFICE,
	AUTHORITY_PROFILES,
	AUTHORITY_ASSISTANCE_CENTER_PILOT,
	NEMO_MOBILITY_BOOKINGS,
	PROFILE_ADMINISTRATION_CHANNELING_SUPERADMIN_KEY,
	PROFILE_ADMINISTRATION_CHANNELING_RULES_ADMIN,
	AUTHORITY_DEALER_PROFILES,
	AUTHORITY_BASE_PROFILES,
	PROFILE_CARGOS_TEAM_MEMBER,
	PROFILES_CLAIMS_AUTHORITY_KEY
} from './permissions-variables';
import {
	FIND_CENTERS_DASHBOARD,
	ROOT_ADMINISTRATION,
	ROOT_AUTHORITY,
	ROOT_BOOKINGS_RELIEF,
	ROOT_CLAIMS_ADMIN,
	ROOT_CLAIMS_COMPLAINT,
	ROOT_CLAIMS_DRIVER,
	ROOT_CLAIMS_OLSA,
	ROOT_CLAIMS_PRACTICE_CAR,
	ROOT_CLAIMS_PRACTICES,
	ROOT_CLAIMS_PUBLIC,
	ROOT_CLAIMS_REPAIR,
	ROOT_CLAIMS_SUPERVISOR,
	ROOT_CLAIMS_THEFT,
	ROOT_CONTRACT_CLOSING_ALD,
	ROOT_CONTRACT_CLOSING_DK_BO,
	ROOT_CONTRACT_CLOSING_DK_C,
	ROOT_CONTRACT_CLOSING_DK_OP,
	ROOT_CONTRACT_CLOSING_SP,
	ROOT_DELIVERY,
	ROOT_INVOICING,
	ROOT_LOGISTICS,
	ROOT_NOT_FOUND_PAGE,
	ROOT_TYRES,
	ROOT_USER_CHANGE_ALD,
	ROOT_USER_CHANGE_SP,
	BOOKINGS_RESERVATION_LIST,
	ROOT_BOOKINGS_PRELEASE,
	ROOT_MOBILITY,
	ROOT_CARGOS
} from './app-routing-roots';
import {CCDKO_DASHBOARD} from '@cc-dekra-operator/cc-dk-o-routing-roots';
import {CCDKC_DASHBOARD} from '@cc-dekra/cc-dk-routing-roots';
import {CCSPO_DASHBOARD} from '@cc-sp-operator/cc-sp-routing-roots';
import {CCALD_DASHBOARD} from '@cc-ald-operator/cc-ald-o-routing-roots';
import {CLAIM_SELECT_PLATE, CLAIMS_DASHBOARD, CLAIMS_LIST, CLAIMS_MYALD_REDIRECT, CLAIMS_PRACTICE_LIST} from './claims/claims-commons/claims-commons-routing-roots';
import {CLAIMS_PRACTICE_CAR_LIST} from './claims/claims-practice-car/claims-practice-car-roots';
import {CLAIM_LIST} from './claims/claims-olsa/claims-olsa-routing-roots';
import {AUTHORITY_DASHBOARD, AUTHORITY_DOSSIER_WORKING_LIST, AUTHORITY_QUOTATIONS_LIST, BACKOFFICE_STATIC, FLOTTA_POOL, VEHICLES_LIST} from './authority/authority-routing-roots';
import {TYRES_OPC_DASHBOARD} from './tyres/opc/tyres-opc-routing-roots';
import {TYRES_OPA, TYRES_OPC, TYRES_OPF, TYRES_OPS} from './tyres/tyres-routing-roots';
import {TYRES_OPA_DASHBOARD} from './tyres/opa/tyres-opa-routing-roots';
import {TYRES_OPF_DASHBOARD} from './tyres/opf/tyres-opf-routing-roots';
import {TYRES_OPS_DASHBOARD} from './tyres/ops/tyres-ops-routing-roots';
import {LOGISTICS_OPL_DASHBOARD} from './logistics/opl/logistics-opl-routing-roots';
import {LOGISTICS_OPAD, LOGISTICS_OPASR, LOGISTICS_OPC, LOGISTICS_OPL} from './logistics/logistics-routing-roots';
import {LOGISTICS_OPAD_RULES} from './logistics/opad/logistics-opad-routing-roots';
import {LOGISTICS_OPC_TRANSFER} from './logistics/opc/logistics-opc-routing-roots';
import {LoaderService} from '@shared/service/loader.service';
import {BookingsRoutingRoots} from './bookings/bookings-routing-roots';
import { MOBILITY_BACKOFFICE_STATIC, MOBILITY_DASHBOARD } from '@mobility/mobility-roots';
import { DL_CARGOS_LIST } from './cargos/cargos-routing-roots';

export const DATA_KEY_MODULE: string = 'module';
export const DATA_KEY_PROFILES: string = 'profiles';

@Injectable()
export class ModulesLoadingGuard implements CanLoad {
	// private environment: AppConfigEnvironment;
	private routeFromProfileMap: Map<string, string> = ROUTE_FROM_PROFILE_MAP;
	private routeFromModuleMap: Map<string, { route: string; permissions: string[] }[]> = ROUTE_FROM_MODULE_MAP;
	private userPermission: UserPermissionsModel;

	constructor(
		private permissionService: PermissionService, 
		private router: Router, 
		private loaderService: LoaderService,
	) {
		this.userPermission = this.permissionService.getCurrentUserPermissions();
	}
/*
	canLoad(route: Route): Observable<boolean> {
		
		// ci passa solo al Loading, dopo loading-redirect.component.ts

		return new Observable<boolean>(observer => {
			const profiles: string[] = Utilities.getValueFromRoute(route, DATA_KEY_PROFILES) as string[];
			if (!Utilities.isVoid(profiles)) {
				this.permissionService.getUserV3Permission()
					.subscribe(
						userPermissions => {
							let hasProfile: boolean = userPermissions.hasProfile(profiles);
							if (!hasProfile) {
								hasProfile = this.redirectRouteWithLastProfile(userPermissions);
							}
							observer.next(hasProfile);
							observer.complete();
						}, () => {
							this.router.navigate([ROOT_NOT_FOUND_PAGE]);
							observer.next(false);
							observer.complete();
						});
			} else {
				observer.next(true);
				observer.complete();
			}
		});
	}

	*/

	canLoad(route: Route): Observable<boolean> {
		
		// ci passa solo al Loading, dopo loading-redirect.component.ts

		return new Observable<boolean>(observer => {
			const profiles: string[] = Utilities.getValueFromRoute(route, DATA_KEY_PROFILES) as string[];
			//if (!Utilities.isVoid(profiles)) {
				this.permissionService.getUserV3Permission()
					.subscribe(
						userPermissions => {
							if (!Utilities.isVoid(profiles)) {
								let hasProfile: boolean = userPermissions.hasProfile(profiles);
								if (!hasProfile) {
									hasProfile = this.redirectRouteFromCurrentProfile(userPermissions);
								}
								//se arrivo da fuori (non navigando i menu nemo) verifico che il profilo corrente recuperato dinamicamente sia effettivamente last_profile_selected, se non lo è aggiorno il BE
								if(hasProfile){
									this.checkAndUpdateCurrentProfile(userPermissions);
								}	
								observer.next(hasProfile);
								observer.complete();
							} else {
								let hasProfile = this.redirectRouteFromCurrentProfile(userPermissions);
								//se arrivo da fuori (non navigando i menu nemo) verifico che il profilo corrente recuperato dinamicamente sia effettivamente last_profile_selected, se non lo è aggiorno il BE
								if(hasProfile){
									this.checkAndUpdateCurrentProfile(userPermissions);
								}
								observer.next(hasProfile);
								observer.complete();
							}								
						}, () => {
							this.router.navigate([ROOT_NOT_FOUND_PAGE]);
							observer.next(false);
							observer.complete();
						});
			/*} else {
				let hasProfile = this.redirectRouteWithLastProfile(userPermissions);
				observer.next(hasProfile);
				observer.complete();
			}
*/		});
	}

	checkAndUpdateCurrentProfile(userPermissions: UserPermissionsModel) {
		if(!userPermissions.getCurrentProfile().last_profile_selected){
			this.permissionService.updateCurrentProfile(this.permissionService.userV3Service.getCurrentUser().id, userPermissions.getCurrentProfile().key).subscribe((res) => {
				this.permissionService.refreshMultiProfileUserPermissionsSync(res, userPermissions.getCurrentProfile().key);
			});
		}
	}

	// perché fa il redirect se lo fa nel loading-redirect.component.ts
	// tanto ci passa solo al loading
	private redirectRouteFromCurrentProfile(user: UserPermissionsModel): boolean {
		
		// // Nome della variabile fuorviante
		// let rootFound: boolean = false;

		// // Filtro il profilo con last_profile_selected = true
		// // altrimenti il routing non va in corrispondenza con il profilo corrente / loop su hasProfile()
		// const profileList: ProfilePermissionModel[] = ((profile_list: ProfilePermissionModel[]) => {
		// 	const res = profile_list.find(x => x.last_profile_selected === true);
		// 	return res ? [res] : profile_list;
		// })(user.profiles);
	
		// profileList.forEach(profile => {
		// 	if (this.routeFromProfileMap.has(profile.key) && !rootFound) {
		// 		rootFound = true;
		// 		this.navigateWithLoader([this.routeFromProfileMap.get(profile.key)]);
		// 	}
		// 	if (this.routeFromModuleMap.has(profile.module.key) && this.routeFromModuleMap.get(profile.module.key).some(item => user.hasPermissions(item.permissions)) && !rootFound) {
		// 		rootFound = true;
		// 		this.navigateWithLoader([this.routeFromModuleMap.get(profile.module.key).filter(item => user.hasPermissions(item.permissions))[0].route]);
		// 	}
		// });
		// if (!rootFound) {
		// 	this.navigateWithLoader([ROOT_NOT_FOUND_PAGE]);
		// }
		// return rootFound;

	

		// prende la route in base al profilo corrente
		const route = this.routeFromProfileMap.get(user.getCurrentProfile().key);

		if (route) {
			return true;
		}
		return false;
	}

	private navigateWithLoader(commands: string[]): void {
		this.loaderService.display(true);
		this.router.navigate(commands).then(() => this.loaderService.display(false));
	}
}


export const ROUTE_FROM_PROFILE_MAP: Map<string, string> = new Map<string, string>([
	// delivery
	[PROFILE_DELIVERY_ASSISTANCE_CENTER_KEY, '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD],
	[PROFILE_DELIVERY_ADMIN_KEY, '/' + ROOT_DELIVERY + '/' + DL_DASHBOARD],
	[PROFILE_DELIVERY_SUPER_USER, '/' + ROOT_DELIVERY + '/' + FIND_CENTERS_DASHBOARD],
	/*[PROFILE_DELIVERY_ASR_KEY, '/' + ROOT_DELIVERY_ASR + '/' + DL_DASHBOARD],*/
	// contract closing
	[PROFILE_CONTRACT_CLOSING_ASSISTANCE_CENTER_KEY, '/' + ROOT_CONTRACT_CLOSING_SP + '/' + CCSPO_DASHBOARD],
	[PROFILE_CONTRACT_CLOSING_SUPER_USER_KEY, '/' + ROOT_CONTRACT_CLOSING_SP + '/' + FIND_CENTERS_DASHBOARD],
	[PROFILE_CONTRACT_CLOSING_SURVEYOR_KEY, '/' + ROOT_CONTRACT_CLOSING_DK_OP + '/' + CCDKO_DASHBOARD],
	[PROFILE_CONTRACT_CLOSING_ADMIN_KEY, '/' + ROOT_CONTRACT_CLOSING_ALD + '/' + CCALD_DASHBOARD],
	[PROFILE_CONTRACT_CLOSING_SUPER_ADMIN_KEY, '/' + ROOT_CONTRACT_CLOSING_ALD + '/' + CCALD_DASHBOARD],
	[PROFILE_CONTRACT_CLOSING_SUPERVISOR_KEY, '/' + ROOT_CONTRACT_CLOSING_ALD + '/' + CCALD_DASHBOARD],
	[PROFILE_CONTRACT_CLOSING_RETURN_APPOINTMENT_MANAGER_KEY, '/' + ROOT_CONTRACT_CLOSING_DK_C + '/' + CCDKC_DASHBOARD],
	[PROFILE_CONTRACT_CLOSING_BACK_OFFICE_KEY, '/' + ROOT_CONTRACT_CLOSING_DK_BO + '/' + CCDKBO_DASHBOARD],
	// claims
	[PROFILE_PUBLIC_USER_KEY, '/' + ROOT_CLAIMS_PUBLIC + '/' + CLAIM_SELECT_PLATE],
	[PROFILE_CLAIMS_MYALD_KEY, '/' + ROOT_CLAIMS_DRIVER + '/' + CLAIMS_MYALD_REDIRECT],
	[PROFILE_CLAIMS_SUPERVISOR_KEY, '/' + ROOT_CLAIMS_SUPERVISOR + '/' + CLAIMS_DASHBOARD],
	[PROFILE_CLAIMS_THEFT_ALD, '/' + ROOT_CLAIMS_THEFT],
	[PROFILE_CLAIMS_THEFT_EXTERNAL, '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST],
	[PROFILE_CLAIMS_REPAIR_KEY, '/' + ROOT_CLAIMS_REPAIR + '/' + CLAIMS_LIST],
	[PROFILE_CLAIMS_REPAIR_SUPERVISOR_KEY, '/' + ROOT_CLAIMS_REPAIR + '/' + CLAIMS_LIST],
	[PROFILE_CLAIMS_ADMIN_KEY, '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_DASHBOARD],
	// [PROFILE_CLAIMS_CUSTOM_ADMIN_KEY, '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_DASHBOARD],
	[PROFILE_CLAIMS_PRACTICE_CAR_KEY, '/' + ROOT_CLAIMS_PRACTICE_CAR + '/' + CLAIMS_PRACTICE_CAR_LIST],
	[PROFILE_CLAIMS_EXTERNAL_KEY, '/' + ROOT_CLAIMS_OLSA + '/' + CLAIM_LIST],
	[PROFILE_CLAIMS_COMPLAINT_READONLY, '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST],
	[PROFILES_CLAIMS_DEKRA_READONLY_KEY, '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST],
	[PROFILE_CLAIMS_REPAIR_READONLY, '/' + ROOT_CLAIMS_REPAIR + '/' + CLAIMS_LIST],
	[PROFILE_CLAIMS_PRACTICE_READONLY, '/' + ROOT_CLAIMS_PRACTICES],
	[PROFILE_CLAIMS_PRACTICE_KEY, '/' + ROOT_CLAIMS_PRACTICES + '/' + CLAIMS_PRACTICE_LIST],
	[PROFILE_CLAIMS_CUSTOMER_SERVICE, '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST],
	[PROFILE_CLAIMS_AON, '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST],
	[PROFILES_CLAIMS_AUTHORITY_KEY, '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST],

	// claims readonly list - Hanno gli stessi comportamenti di PROFILES_CLAIMS_DEKRA_READONLY_KEY
	...PROFILE_CLAIMS_READONLY_LIST.map((x: string) => [x, '/' + ROOT_CLAIMS_COMPLAINT + '/' + CLAIMS_LIST]) as [[string, string]],
	
	...CLAIMS_CUSTOM_ADMIN_PROFILES.map((x: string) => [x, '/' + ROOT_CLAIMS_ADMIN + '/' + CLAIMS_DASHBOARD]) as [[string, string]],
	
	// invoicing
	[PROFILE_INVOICING_ADMIN_KEY, '/' + ROOT_INVOICING + '/' + INVOICING_DASHBOARD],
	[PROFILE_INVOICING_ASSISTANCE_CENTER_KEY, '/' + ROOT_INVOICING + '/' + INVOICING_DASHBOARD],
	// tyres
	[PROFILE_TYRES_ASSISTANCE_CENTER_KEY, '/' + ROOT_TYRES + '/' + TYRES_OPC + '/' + TYRES_OPC_DASHBOARD],
	[PROFILE_TYRES_CENTER_SUPER_USER, '/' + ROOT_TYRES + '/' + TYRES_OPC + '/' + FIND_CENTERS_DASHBOARD],
	[PROFILE_TYRES_ADMIN_KEY, '/' + ROOT_TYRES + '/' + TYRES_OPA + '/' + TYRES_OPA_DASHBOARD],
	[PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY, '/' + ROOT_TYRES + '/' + TYRES_OPF + '/' + TYRES_OPF_DASHBOARD],
	[PROFILE_TYRE_CUSTOMER_SERVICE_KEY, '/' + ROOT_TYRES + '/' + TYRES_OPS + '/' + TYRES_OPS_DASHBOARD],
	// change user
	[PROFILE_USER_CHANGE_ADMIN_KEY, '/' + ROOT_USER_CHANGE_ALD + '/' + UC_DASHBOARD],
	[PROFILE_USER_CHANGE_ASSISTANCE_CENTER_KEY, '/' + ROOT_USER_CHANGE_SP + '/' + UC_DASHBOARD],
	[PROFILE_USER_CHANGE_SUPER_USER_KEY, '/' + ROOT_USER_CHANGE_SP + '/' + FIND_CENTERS_DASHBOARD],
	// logistics
	[PROFILE_LOGISTIC_TEAM_MEMBER_KEY, '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPL + '/' + LOGISTICS_OPL_DASHBOARD],
	[PROFILE_LOGISTIC_ASR_KEY, '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPASR + '/' + LOGISTICS_OPL_DASHBOARD],
	[PROFILE_LOGISTIC_CONSULTATION_KEY, '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPC + '/' + LOGISTICS_OPC_TRANSFER],
	[PROFILE_LOGISTIC_ADMIN_KEY, '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPAD + '/' + LOGISTICS_OPAD_RULES],
	[PROFILE_LOGISTIC_CENTER_SUPER_USER_KEY, '/' + ROOT_LOGISTICS + '/' + LOGISTICS_OPASR + '/' + FIND_CENTERS_DASHBOARD],
	// administration
	[PROFILE_ADMINISTRATION_SUPERADMIN_KEY, '/' + ROOT_ADMINISTRATION],
	[PROFILE_ADMINISTRATION_CHANNELING_SUPERADMIN_KEY, '/' + ROOT_ADMINISTRATION],
	[PROFILE_ADMINISTRATION_ADMIN_KEY, '/' + ROOT_ADMINISTRATION],
	[PROFILE_ADMINISTRATION_USER_MANAGEMENT_SUPERADMIN_KEY, '/' + ROOT_ADMINISTRATION],
	[PROFILE_ADMINISTRATION_USER_MANAGEMENT_ADMIN_KEY, '/' + ROOT_ADMINISTRATION],
	[PROFILE_ADMINISTRATION_CHANNELING_ADMIN_KEY, '/' + ROOT_ADMINISTRATION],
	[PROFILE_ADMINISTRATION_CHANNELING_RULES_ADMIN, '/' + ROOT_ADMINISTRATION],
	[PROFILE_ADMINISTRATION_CHANNELING_RULES_SUPERADMIN, '/' + ROOT_ADMINISTRATION],

	//Booking prelease super user
	[PRELEASE_CENTER_SUPER_USER, '/' + ROOT_BOOKINGS_PRELEASE + '/' + FIND_CENTERS_DASHBOARD],

	// TODO
	// Questi profili vanno mappati bene, è inutile fare la .find() 
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_bookings_team_supervisor'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + AUTHORITY_DASHBOARD],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_bookings_team'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + AUTHORITY_DASHBOARD],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_assistance_center'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_rac_center'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_customer_finance'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_sales'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_customer_service'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_customer_service_supervisor'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_fleet_manager'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_prelease_driver'),'/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='prelease_bookings_team'), '/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='prelease_bookings_team_supervisor'), '/' + ROOT_BOOKINGS_PRELEASE + '/' + BOOKINGS_RESERVATION_LIST],
	
	//Booking relief super user. 
	[RELIEF_CENTER_SUPER_USER, '/' + ROOT_BOOKINGS_RELIEF + '/' + FIND_CENTERS_DASHBOARD],

	//Booking relief
	
	// TODO
	// Questi profili vanno mappati bene, è inutile fare la .find() 
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_customer_service'), '/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_bookings_team'),'/' + ROOT_BOOKINGS_RELIEF + '/' + AUTHORITY_DASHBOARD],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_assistance_center'),'/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_rac_center'),'/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_customer_finance'),'/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_sales'),'/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_customer_service_supervisor'),'/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_bookings_team_supervisor'),'/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_fleet_manager'),'/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='module_relief_driver'),'/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='relief_bookings_team'), '/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],
	[BOOKINGS_PROFILES.find(elem => elem==='relief_bookings_team_supervisor'), '/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST],

	// Mobility Bookings
	// NEMO_MOBILITY_BOOKINGS
	...NEMO_MOBILITY_BOOKINGS.map((x: string) => [x, '/' + ROOT_BOOKINGS_RELIEF + '/' + BOOKINGS_RESERVATION_LIST]) as [[string, string]],
	

	//flotta pool
	[FLOTTA_POOL_PROFILES.find(elem => elem==='flotta-pool_dev'),'/' + FLOTTA_POOL + '/' + AUTHORITY_DASHBOARD],
	[FLOTTA_POOL_PROFILES.find(elem => elem==='flotta-pool_center_super_user'),'/' + FLOTTA_POOL + '/' + AUTHORITY_DASHBOARD + '/' + VEHICLES_LIST],
	[FLOTTA_POOL_PROFILES.find(elem => elem==='flotta-pool_assistance_center'),'/' + FLOTTA_POOL + '/' + AUTHORITY_DASHBOARD + '/' + VEHICLES_LIST],
	
	// AUTHORITY
	// i profili dealer e center super user hanno un'altra landing page
	...[ ...AUTHORITY_PROFILES.filter(x => ![...AUTHORITY_DEALER_PROFILES, AUTHORITY_CENTER_SUPER_USER].includes(x)), AUTHORITY_ASSISTANCE_CENTER_PILOT ].map((x: string) => [x, '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_DOSSIER_WORKING_LIST]) as [[string, string]],

	// i profili dealer vanno sulla dashboard dei ricambi
	...[ ...AUTHORITY_DEALER_PROFILES ].map((x: string) => [x, '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_QUOTATIONS_LIST]) as [[string, string]],

	// il Center Super User deve andare nella ricerca centri
	[AUTHORITY_CENTER_SUPER_USER, '/' + ROOT_AUTHORITY + '/' + FIND_CENTERS_DASHBOARD],
	// [AUTHORITY_CENTER_SUPER_USER, '/' + ROOT_AUTHORITY + '/' + AUTHORITY_DASHBOARD + '/' + AUTHORITY_DOSSIER_WORKING_LIST],

	// MOBILITY
	...MOBILITY_MYMOBILITY_PROFILE_USER.map((x: string) => [x, '/' + ROOT_MOBILITY + '/' + MOBILITY_DASHBOARD]) as [[string, string]],
	...NEMO_MOBILITY_AUTHORITY_BACKOFFICE.map((x: string) => [x, '/' + ROOT_MOBILITY + '/' + MOBILITY_BACKOFFICE_STATIC]) as [[string, string]],

	//CARGOS 
	[PROFILE_CARGOS_TEAM_MEMBER, '/' + ROOT_CARGOS + '/' + DL_CARGOS_LIST],


]);

export const ROUTE_FROM_MODULE_MAP: Map<string, { route: string; permissions: string[] }[]> = new Map<string, { route: string; permissions: string[] }[]>([
	[MODULE_AUTHORITY_KEY, [{
		route: `/${ROOT_AUTHORITY}/${AUTHORITY_DASHBOARD}/${AUTHORITY_DOSSIER_WORKING_LIST}`,
		permissions: [AuthorityUsersPermissions.authority_admin_dashboard, AuthorityUsersPermissions.authority_administrative_practice_dashboard,
		AuthorityUsersPermissions.authority_appointment_dashboard, AuthorityUsersPermissions.authority_dashboard,
		AuthorityUsersPermissions.authority_dealer_dashboard, AuthorityUsersPermissions.authority_supervisor_dashboard, AuthorityUsersPermissions.authority_merged_dashboard]
	}]],
	[
		MODULE_BOOKINGS_KEY,
			[
				{
					route: `/${ROOT_BOOKINGS_RELIEF}/${BookingsRoutingRoots.DASHBOARD}`,
					permissions: [BookingsPermissions.bookings_relief_can_view_dashboard]
				},
				{
					route: `/${ROOT_BOOKINGS_RELIEF}/${BookingsRoutingRoots.RESERVATION_LIST}`,
					permissions: [BookingsPermissions.bookings_relief_can_retrieve_bookings_list]
				}
		]
	]
]);
